import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Upload, message, Avatar, Select } from 'antd';
import styled from 'styled-components';
import { AVATARS, BASE } from 'api';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { RHFInput } from 'react-hook-form-input';
import { yupResolver } from '@hookform/resolvers';
import * as yup from 'yup';
import { ReactComponent as Open } from '../../../images/eyes_open.svg';
import { ReactComponent as Close } from '../../../images/eyes_gray_close.svg';
import Form from './FormStyled';
const { Option } = Select;
const SelectStyle = styled(Select)`
  &&& {
    width: 100%;
    margin-bottom: 20px;
    .ant-select-selector {
      border-radius: 12px;
    }
  }
`;
function Info({ data, updateData }) {
  const { t, i18n } = useTranslation();
  const [imgUrl, setImgUrl] = useState({
    loading: false,
    url: null,
  });

  const SignupSchema = yup.object().shape({
    first_name: yup.string().required(),
    last_name: yup.string().required(),
    email: yup.string().required(),
    phone: yup.string().required(),
    old_password: yup.string(),
    password: yup.string(),
  });

  const { handleSubmit, register, setValue, errors } = useForm({
    resolver: yupResolver(SignupSchema),
  });

  const saveChange = (data) => {
    if (imgUrl.url) {
      updateData({
        ...data,
        avatar: imgUrl.url,
      });
    } else {
      updateData({
        ...data,
        old_password: 'password',
      });
    }
  };

  const uploadButton = (
    <div className="uploadButton">
      <div className="ant-upload-text">{t('uploadPhoto')}</div>
    </div>
  );

  const getUploadProps = () => {
    return {
      name: 'file',
      action: `v1${AVATARS}`,
      headers: {
        Authorization: `OAuth ${localStorage.getItem('access_token')}`,
      },
      showUploadList: false,
      listType: 'picture-card',
      className: 'avatar-uploader',
      onChange({ file }) {
        if (file.status === 'done') {
          setImgUrl({ ...imgUrl, url: file.response });
        } else if (file.status === 'error') {
          message.error(`${file.name} file upload failed.`);
        }
      },
    };
  };

  const handleChange = (value) => {
    if (value === 'en') {
      i18n.changeLanguage('en');
    } else {
      i18n.changeLanguage('ru');
    }
    updateData({
      language: value,
    });
  };

  return (
    <div>
      <SelectStyle defaultValue={data.language} onChange={handleChange}>
        <Option value="ru">{t('rus')}</Option>
        <Option value="en">{t('eng')}</Option>
      </SelectStyle>
      <Form
        onSubmit={handleSubmit((data) => {
          saveChange(data);
        })}
      >
        <div className="wrapper mb-10">
          <div className="mb-20">
            <Upload {...getUploadProps()}>
              {imgUrl.url ? (
                <div
                  style={{
                    width: '100%',
                    backgroundImage: `url(${BASE}${imgUrl.url})`,
                    height: '100%',
                    backgroundSize: 'cover',
                    borderRadius: '100px',
                  }}
                />
              ) : data.avatar ? (
                <Avatar
                  src={`${BASE}${data.avatar}`}
                  className="w-42 flex items-center justify-center h-42"
                />
              ) : (
                <Avatar className="w-42 flex items-center justify-center h-42">
                  {data.first_name[0]}
                </Avatar>
              )}
              {uploadButton}
            </Upload>
          </div>
          <div className="relative mb-20">
            <RHFInput
              as={<Input addonBefore={t('name')} />}
              rules={{ required: true }}
              name="first_name"
              register={register}
              setValue={setValue}
              defaultValue={data.first_name}
            />
            {errors.first_name && (
              <span className="validate">{t('reqField')}</span>
            )}
          </div>
          <div className="relative mb-20">
            <RHFInput
              as={<Input addonBefore={t('surname')} />}
              rules={{ required: true }}
              name="last_name"
              register={register}
              setValue={setValue}
              defaultValue={data.last_name}
            />
            {errors.last_name && (
              <span className="validate">{t('reqField')}</span>
            )}
          </div>
          <div className="relative mb-20">
            <RHFInput
              as={<Input addonBefore={t('email')} />}
              rules={{ required: true }}
              name="email"
              setValue={setValue}
              register={register}
              defaultValue={data.email}
            />
            {errors.email && <span className="validate">{t('reqField')}</span>}
          </div>
          <div className="relative mb-20">
            <RHFInput
              as={<Input addonBefore={t('numPhone')} />}
              rules={{ required: true }}
              name="phone"
              setValue={setValue}
              register={register}
              defaultValue={data.phone}
            />
            {errors.phone && <span className="validate">{t('reqField')}</span>}
          </div>
        </div>
        <div className="wrapper mb-20">
          <div className="relative mb-20">
            <RHFInput
              as={
                <Input.Password
                  iconRender={(visible) => (visible ? <Open /> : <Close />)}
                  addonBefore={t('oldPassword')}
                />
              }
              name="old_password"
              setValue={setValue}
              register={register}
            />
          </div>
          <div className="relative mb-20">
            <RHFInput
              as={
                <Input.Password
                  iconRender={(visible) => (visible ? <Open /> : <Close />)}
                  addonBefore={t('newPassword')}
                />
              }
              rules={{ required: true }}
              name="password"
              setValue={setValue}
              register={register}
            />
          </div>
          {errors.password && <span className="validate">{t('reqField')}</span>}
        </div>
        <Button
          type="primary"
          className="rounded-md w-full h-52 flex justify-center items-center"
          htmlType="submit"
        >
          {t('saveChange')}
        </Button>
      </Form>
    </div>
  );
}

Info.propTypes = {};

export default Info;
